export default {
    roles: (state) => state.roles,
    permissionGroups: (state) => state.permissionGroups,
    loading: (state) => state.loading,
    roleById: (state) => (id) =>
        state.roles.find((role) => String(role.id) === String(id)) || null
}
